import { jsx } from 'react/jsx-runtime';
import { BaseTileTargetAdditional } from '@vp/swan';

const TemplateTileColorSwatchContent = ({ children }) => /* @__PURE__ */ jsx(BaseTileTargetAdditional, { children });

export { TemplateTileColorSwatchContent };
